"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.randomIntBetween = void 0;
const randomIntBetween = (min, max) => {
    const minInt = Math.ceil(min);
    const maxInt = Math.floor(max);
    return Math.floor(Math.random() * (maxInt - minInt) + minInt);
};
exports.randomIntBetween = randomIntBetween;
